"use strict";

module.exports = {
    "i-services": {
        "404": "404",
        "adresa": "Adresler",
        "advertising": "Reklam",
        "afisha": "Afiş",
        "all": "Tüm servisler",
        "api": "API",
        "appmetrica": "AppMetrica",
        "appsearch": "Uygulamalar",
        "audience": "Audience",
        "auto": "Oto",
        "autoru": "auto.ru",
        "avia": "Bilet",
        "aziada": "Aziada",
        "ba": "Display",
        "backapv": "Yandex.Haritalar İş Ortağı",
        "balance": "Bakiye",
        "bar": "Bar",
        "bar-ie": "IE için Bar",
        "bar-ie9": "IE9 için Bar",
        "bayan": "Display",
        "blogs": "Bloglar",
        "books": "Kitaplar",
        "browser": "Browser",
        "calendar": "Takvim",
        "captcha": "Eyvah",
        "catalogwdgt": "Widget kataloğu",
        "chrome": "Yandex arama özelliğine sahip Chrome",
        "city": "Şehirler",
        "cityday": "Şehrin kuruluş günü",
        "clickhouse": "ClickHouse",
        "collection": "Koleksiyon",
        "company": "Şirket",
        "contest": "Yarışma",
        "delivery": "Delivery",
        "desktop": "Kişisel arama",
        "direct": "Direct",
        "direct.market": "Market",
        "disk": "Disk",
        "display": "Display",
        "ege": "Üniversite Sınavı",
        "expert": "Uzman",
        "feedback": "Bize ulaşın",
        "feedback2": "Bize ulaşın",
        "ff": "Yandex arama özelliğine sahip FF",
        "fotki": "Foto",
        "fresh": "Güncel",
        "games": "Oyunlar",
        "geocontext": "Coğrafi içerik",
        "goroda": "Şehirler",
        "help": "Yardım",
        "i": "Servislerim",
        "ie": "Yandex arama özelliğine sahip IE",
        "images": "Görsel",
        "images-com": "Görsel",
        "interests": "İlgi alanları",
        "internet": "İnternetmetre",
        "kassa": "Kasa",
        "keyboard": "Klavye",
        "kraski": "Renkler",
        "kuda": "Herkes nereye gidiyor",
        "large": "Görme bozukluğu olanlar için Yandex",
        "legal": "Yasal belgeler",
        "lenta": "Beslemeler",
        "libra": "Kütüphane",
        "literacy": "Doğru dil kullanma haftası",
        "local": "Lokal ağ",
        "lost": "Eski servisler",
        "love": "Karşılıklı çekim günü",
        "mail": "Mail",
        "maps": "Haritalar",
        "maps-wiki": "Kullanıcı haritası",
        "market": "Market",
        "market.advertising": "Market",
        "master": "Uzman",
        "metrika": "Metrika",
        "metro": "Metro",
        "mobile": "Mobil",
        "moikrug": "Moy Krug",
        "money": "Money",
        "museums": "Tarihi Kültür Mirası Günleri",
        "music": "Müzik",
        "music-partner": "Müzik: İstatistikler",
        "nahodki": "Bulduklarım",
        "nano": "Nano",
        "newhire": "Yeni kiralama",
        "news": "Haberler",
        "notifications": "Bildirim paneli",
        "oauth": "Giriş",
        "online": "Çevrimiçi",
        "openid": "OpenID",
        "opera": "Opera Software",
        "opinion": "Alıntılar",
        "partners": "Reklam ağı",
        "partnersearch": "İş ortakları için arama",
        "passport": "Pasaport",
        "pdd": "Kurumlar için Mail",
        "peoplesearch": "Kişi arama",
        "perevod": "Çeviri",
        "probki": "Trafik",
        "pulse": "Bloglar: Nabız",
        "punto": "Punto switcher",
        "pvo": "Yanıtlar",
        "rabota": "Kariyer",
        "radar": "Radar",
        "ramazan": "Ramazan",
        "rasp": "Seyahat",
        "realty": "Emlak",
        "referats": "Tezler",
        "rk": "Sorularım var",
        "root": "Unix kullanıcıları için Yandex.Olimpiyat",
        "school": "Okul",
        "search": "Arama",
        "server": "Sunucu",
        "shtrafi": "Cezalar",
        "site": "Site için arama",
        "slovari": "Sözlükler",
        "so": "Savunma",
        "social": "Sosyal",
        "soft": "Uygulamalar",
        "sport": "Spor",
        "sprav": "Rehber",
        "start": "Başlangıç sayfası",
        "stat": "İstatistikler",
        "subs": "Abonelikler",
        "taxi": "Taksi",
        "telephony": "Телефония",
        "terms": "İnternet rehberi",
        "tests": "Testler ve anketler",
        "tickets": "Biletler",
        "time": "Yandex.Saat",
        "toloka": "Yandex.Toloka",
        "toster": "Kutlama konuşması",
        "translate": "Çeviri",
        "tune": "Ayarlar",
        "tv": "TV",
        "uslugi": "Hizmetler",
        "video": "Video",
        "video-com": "Video",
        "vno": "ZNO",
        "wdgt": "Widgets",
        "weather": "Hava durumu",
        "webmaster": "Webmaster",
        "webmaster-api": "Webmaster API",
        "widgets": "Widgets",
        "wordstat": "İstatistikler",
        "wow": "Ya.ru",
        "www": "Web",
        "xmlsearch": "XML",
        "yaca": "Katalog",
        "yamb": "Görüntülü Reklam",
        "zakladki": "Favoriler"
    }
};